import React from 'react';

const HowItWorks: React.FC = () => {
  const actions = [
    {
      title: "Réparer",
      icon: "🔧",
      description: "Prolongez la durée de vie de vos objets en les réparant et gagnez des points."
    },
    {
      title: "Vendre & Acheter",
      icon: "🔄",
      description: "Achetez et vendez des produits d'occasion ou reconditionnés."
    },
    {
      title: "Donner & Prêter",
      icon: "🤝",
      description: "Donnez une seconde vie à vos objets en les prêtant ou en les offrant."
    },
    {
      title: "Louer",
      icon: "🏷️",
      description: "Louez des objets au lieu de les acheter pour une consommation plus responsable."
    }
  ];

  return (
    <section id="how-it-works" className="how-it-works">
      <div className="container">
        <h2 className="section-title">Comment ça fonctionne</h2>
        <p className="section-subtitle">Une application simple pour tous les gestes de consommation responsable</p>
        
        <div className="actions-grid">
          {actions.map((action, index) => (
            <div key={index} className="action-card">
              <div className="action-icon">{action.icon}</div>
              <h3>{action.title}</h3>
              <p>{action.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
